import React from "react";
import PropTypes from "prop-types";
import styles from "./Media.module.scss";

export default function Media({ 
  avatarLink = "#pablo",
  avatar,
  avatarAlt = "...",
  title,
  body,
  footer,
  innerMedias,
  ...rest 
}) {
  return (
    <div {...rest} className={styles.media}>
      <a href={avatarLink} className={styles.mediaLink}>
        <div className={styles.mediaAvatar}>
          <img src={avatar} alt={avatarAlt} />
        </div>
      </a>
      <div className={styles.mediaBody}>
        {title !== undefined ? (
          <h4 className={styles.mediaHeading}>{title}</h4>
        ) : null}
        {body}
        <div className={styles.mediaFooter}>{footer}</div>
        {innerMedias !== undefined
          ? innerMedias.map((prop) => {
              return prop;
            })
          : null}
      </div>
    </div>
  );
}

Media.propTypes = {
  avatarLink: PropTypes.string,
  avatar: PropTypes.string,
  avatarAlt: PropTypes.string,
  title: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  innerMedias: PropTypes.arrayOf(PropTypes.object)
};